import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import AdminSelect, { SIZE_COMPACT } from '../AdminSelect';
import styles from './styles';
import DatePropTypes from '../../propTypes/dates';
import { monthOptions } from '../../utils/dates';

class MonthPicker extends Component {
    render() {
        const { classes, value, ...props } = this.props;
        return (
            <AdminSelect
                type={SIZE_COMPACT}
                className={classes.root}
                value={value}
                options={monthOptions}
                {...props}
            />
        );
    }
}

MonthPicker.propTypes = {
    // From withStyles we expect to get classes.
    classes: PropTypes.object.isRequired,

    // Value must be a weekday in short format or 'none'.
    value: DatePropTypes.month,
};

MonthPicker.defaultProps = {
    value: 'none',
};

export default withStyles(styles)(MonthPicker);
